export default function (totalCharge, quantity, card) {
  gtag("event", "purchase", {
    allow_custom_scripts: true,
    value: totalCharge,
    transaction_id: card?.id,
    send_to: "DC-2946534/milsa048/frallmb+items_sold",
    quantity,
    u1: "purchase",
    u2: new Date().toString(),
    u4: new Date().toString(),
    u5: card.address_state,
    u6: card.address_zip,
  });
  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    quantity,
  });
}
